"use client";

import { useAuthStore } from "@/lib/store";
import { useEffect } from "react";
import { setUserId } from "@/lib/gtag";

export default function AuthTracker() {
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (user?.id) {
      setUserId(user.id);
    }
  }, [user?.id]);

  return null;
}
